<template>
    <a :href="`/admin/pages/floors/${item.id}`" v-if="item">
        <span
            class="text-nowrap inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-pink-100 text-pink-800">
            {{ item.name }}
        </span>
    </a>
</template>

<script>
export default {
    name: "FloorItem",

    props: ['item'],
}
</script>

<style scoped>

</style>
